import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid, TextField, useTheme } from "@material-ui/core";
import axios from "axios";
import * as sweetalert from "sweetalert";
import Cookies from "js-cookie";
import { tokens } from "../../../styles/theme";
import packageJson from "../../../../package.json";
import Controls from "../global/controls/Controls";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const ResendCode = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(false);

  const [forgetpassword, setforgetpassword] = useState({
    mobile_number: "",
    mobileNumberError: "", // New state for mobile number error
  });
  const validate = () => {
    let isValid = true;
    const { mobile_number } = forgetpassword;

    // Basic validation example, customize based on your needs
    if (!mobile_number) {
      setforgetpassword({
        ...forgetpassword,
        mobileNumberError: "رقم الهاتف مطلوب",
      });
      isValid = false;
    } else if (!/^\d+$/.test(mobile_number)) {
      setforgetpassword({
        ...forgetpassword,
        mobileNumberError: "يجب أن يحتوي رقم الهاتف على أرقام فقط",
      });
      isValid = false;
    } else if (mobile_number.length !== 10) {
      setforgetpassword({
        ...forgetpassword,
        mobileNumberError: "يجب أن يكون رقم الهاتف 10 أرقام",
      });
      isValid = false;
    }

    return isValid;
  };
  const handeleInput = (e) => {
    e.persist();
    setforgetpassword({
      ...forgetpassword,
      [e.target.name]: e.target.value,
      mobileNumberError: "", // Clear the error when typing
    });
  };
  // setforgetpassword({ ...forgetpassword, [e.target.name]: e.target.value });

  const forgetSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      const data = {
        mobile_number: forgetpassword.mobile_number,
      };
      const config = {
        headers: {
          Accept: "application/json",
          Authorization: null,
          sameSite: "strict",
          httpOnly: "false",
          seurce: "true",
          Cookie: Cookies.get("jwt"),
        },
      };
      axios
        .post(`${BaseUrl}/api/resend/code`, data, config, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
            navigate("/reset-password");
          } else if (res.data.status === false) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
        });
    }
  };
  useEffect(() => {
    if (loading === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoading(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  return (
    <div>
      <form className="form-group" onSubmit={forgetSubmit}>
        <Grid container style={{ minHeight: "100vh" }}>
          <Grid item className="home-item" xs={12} sm={6}>
            <h1 style={{ textAlign: "center" }}>ليرتنا كاش</h1>
            <p>
              {" "}
              صمم هذا التطبيق ليكون أداة مساعدة لمراكز تعبئة الرصيد في سوريا،
              فهو مخصص لتحويل الوحدات و تسديد الفواتير لشبكتي سيرياتل و ام تي ان
              بسهولة بالغة، يقدم إمكانية إدارة موزعين الجملة و مراكز الخدمة في
              مختلف المحافظات و المناطق مع إمكانية حفظ الزبائن في قاعدة البيانات
              و بالتالي يمكن التحويل للعميل من خلال اختيار اسمه وتحديد كمية
              الوحدات فقط، كما أنه يمكن حفظ نسخة من التقارير بأنواعها المختلفة
              ضمن سجل خاص{" "}
            </p>
            <img src="hom.svg" alt="login-img" />
          </Grid>
          <Grid
            container
            item
            alignItems="center"
            direction="column"
            justify="center"
            xs={12}
            sm={6}
            style={{ padding: 10 }}
          >
            <div>
              <h2 className="title-home">إعادة إرسال رمز التحقق </h2>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TextField
                className="form-control"
                variant="outlined"
                label="رقم الهاتف"
                fullWidth
                type="text"
                name="mobile_number"
                onChange={handeleInput}
                value={forgetpassword.mobile_number}
                error={!!forgetpassword.mobileNumberError}
                helperText={forgetpassword.mobileNumberError}
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },

                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
              {loading === true ? (
                <>
                  <Controls.Button
                    text=<div class="spinner center">
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                    </div>
                    variant="contained"
                    className="btn-submit resend-code"
                  ></Controls.Button>
                </>
              ) : (
                <Controls.Button
                  type="submit"
                  text="إرسال"
                  variant="contained"
                  className="btn-submit"
                ></Controls.Button>
              )}
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
